<template>
  <div class="h-full">
    <RouterView />
    <div
      class="w-full flex flex-col items-center justify-between text-sm text-white py-20 px-40
      bg-secondary-dark tablet:flex-row tablet:py-25 laptop:py-30"
    >
      <p class="flex-shrink">
        © 2026 ClickOn GmbH. Alle Rechte vorbehalten
      </p>
      <p
        v-if="$route.name !== 'PublicVehicle'"
        class="flex-shrink-0 flex items-center mt-10 tablet:mt-0"
      >
        <span class="whitespace-no-wrap mr-10">
          Powered by
        </span>
        <a
          href="https://clickon.ch"
          target="_blank"
        >
          <img
            src="/images/clickon-logo-white.svg"
            alt="ClickOn GmbH"
            class="h-30"
          >
        </a>
      </p>
    </div>
  </div>
</template>


<script>
export default {};
</script>
